import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../filter/FilterButton'

const FilterButtonUser = ({ module = 'dataEntrySurvey'}) => {
  const open = useSelector(state => state?.filter?.[module]?.open || false)

  return (
    <>
      <FilterButton 
        module={module} 
        keysFilter={['rolesId', 'templateId']} 
        keepReload={false}
      />
      { open &&
        <FilterDialog module={module} />
      }
    </>
  )
}
export default FilterButtonUser